import styled from "styled-components";

import { minMedia } from "container/global.styles";

const Container = styled.div`
    ${(props) => (props.withColor ? "padding" : "margin")}: 25px 0 25px;

    ${minMedia.desktop`
        display: grid;
        text-align: center;
        ${(props) => (props.withColor ? "padding" : "margin")}: 70px 0 70px;
   `};
`;

const TextContainer = styled.div`
    text-align: ${(props) => props.textAlignMobile ?? "left"};
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }

    ${minMedia.desktop`
        margin-bottom: 30px;
        text-align: ${(props) => props.textAlignDesktop ?? "center"};
    `};
`;

const PillarList = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${minMedia.desktop`
        flex-direction: row;
    `};
`;

const BtnWrapper = styled.div`
    margin: 25px 0;

    ${minMedia.desktop`
        margin: 50px auto 0;
        width: 350px;
    `};
`;

export default {
    Container,
    TextContainer,
    PillarList,
    BtnWrapper,
};
